import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import Api from "src/Config";

export const MonitoringOverviewContext = createContext(null);

type Props = {
  children: ReactElement;
};

const MonitoringOverviewProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["monitoring_overview"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`tm/overview?checkType=main`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      isLoading,
      data,
      error,
      isFetching,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <MonitoringOverviewContext.Provider value={contextValue}>
      {children}
    </MonitoringOverviewContext.Provider>
  );
};

export default MonitoringOverviewProvider;
